<!--
  A submitted review as the conversation shows it: who, the verdict, when
  and on which snapshot, the summary, and its inline comments, folded until
  the reader unfolds them (ReviewComments). The inside of its card, in the
  Overview's conversation and the Review view's alike.
-->
<script lang="ts">
  import type { PrStore } from '../state/pr.svelte';
  import { REVIEW_WORD, reviewAt, type ReviewItem } from '../logic/reviewConversation';
  import { relTime } from '../logic/time';
  import Html from './Html.svelte';
  import ReviewComments from './ReviewComments.svelte';
  import SnapshotChip from './SnapshotChip.svelte';

  interface Props {
    pr: PrStore;
    review: ReviewItem;
  }
  let { pr, review }: Props = $props();
</script>

<div class="comment-head">
  <b>{review.author?.login ?? 'ghost'}</b>
  <span class="pill {review.state === 'APPROVED' ? '' : review.state === 'CHANGES_REQUESTED' ? 'bad' : 'neutral'}">{REVIEW_WORD[review.state] ?? review.state}</span>
  <span title={reviewAt(review)}>{relTime(reviewAt(review))}</span>
  <SnapshotChip {pr} commit={review.reviewCommit?.oid} at={reviewAt(review)} />
</div>
{#if review.body.trim()}<Html html={review.bodyHTML} md={review.body} />{/if}
{#if review.comments.totalCount}<ReviewComments {pr} review={review.id} count={review.comments.totalCount} />{/if}
